import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography
} from '@mui/material';

const ModalRecuperaCessao = ({
  open,
  onClose,
  loadingProsseguir,
  nomeEtapaCapitalFlow,
  comecarNovajornada,
  navegarTelaCapitalFlow
}) => (
  <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth className="dialog-conta">
    <DialogTitle className="titulo-modal">Continuar a jornada?</DialogTitle>

    <DialogContent className="dialog-conta__content">
      <Typography variant="body2" className="dialog-conta__subtitle font-ajuste">
        Você possui um Capital Flow em andamento na etapa de <b>{nomeEtapaCapitalFlow}</b>. Deseja
        continuar de onde parou ou iniciar uma nova operação?
      </Typography>
      <Typography variant="body2" className="dialog-conta__subtitle">
        <b>Atenção:</b> iniciar uma nova operação excluirá definitivamente o rascunho anterior.
      </Typography>
    </DialogContent>

    <DialogActions className="dialog-conta__actions modal-confirmacao-conta">
      <Button
        variant="outlined"
        color="inherit"
        onClick={() => comecarNovajornada()}
        className="dialog-conta__btn"
        disabled={loadingProsseguir}
      >
        Iniciar nova
      </Button>

      <Button
        variant="contained"
        onClick={() => navegarTelaCapitalFlow()}
        className="dialog-conta__btn-escolher"
        disabled={loadingProsseguir}
      >
        Continuar
        {loadingProsseguir && <CircularProgress size={20} color="inherit" />}
      </Button>
    </DialogActions>
  </Dialog>
);

export default ModalRecuperaCessao;
